import { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartContext = createContext(null);
const KEY = "ipc_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: Math.min(99, copy[idx].quantity + qty) };
        return copy;
      }
      return [...prev, {
        product_id: product.id, name: product.name, price: product.price,
        image: product.image, quantity: qty, brand: product.brand,
      }];
    });
  };

  const updateQty = (product_id, quantity) => {
    setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, quantity } : i).filter((i) => i.quantity > 0));
  };

  const removeItem = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
  const shipping = subtotal >= 99 || subtotal === 0 ? 0 : 12.99;
  const tax = +(subtotal * 0.0725).toFixed(2);
  const total = +(subtotal + shipping + tax).toFixed(2);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, subtotal, shipping, tax, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
